<template>
  <b-form @submit="onSubmit" class="input-wrapper">
    <b-form-input
      v-model="form.query"
      type="text"
      required
      :placeholder="placeholder"
    ></b-form-input>
    <slot></slot>
    <b-button
      class="search-button"
      type="submit"
      variant="primary"
    >
      <font-awesome-icon icon="search" size="lg"></font-awesome-icon>
    </b-button>
  </b-form>
</template>


<script>
export default {
  name: "search-form",
  props: {
    placeholder: String,
  },
  data () {
    return {
      form: {
        query: undefined,
      },
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault();
      this.$emit("search", this.form.query);
    },
  },
};
</script>


<style lang="scss" scoped>
.input-wrapper {
  position: relative;
}

.search-button {
  background: $corp-color1;
  display: block;
  position: absolute;
  top: 0px;
  right: 0px;
  border: none;
  color: white;
  text-align: center;
  width: 32px;
  min-width: 32px !important;
  height: 100%;
  padding: 4px !important;
}
</style>
